export const Experiments = {
  b2c_041_fundraising_page_donation_prompts_2:
    'b2c_041_fundraising_page_donation_prompts_2',
  b2c_045_donate_button_color: 'b2c_045_donate_button_color',
  b2c_029_first_to_donate: 'b2c_029_first_to_donate',
  b2c_040_frp_trust_proposition_bar: 'b2c_040_frp_trust_proposition_bar',
  b2c_044_donate_to_yourself: 'b2c_044_donate_to_yourself',
  no_tip_jar_on_amount_page_desktop: 'no_tip_jar_on_amount_page_desktop',
  no_tip_jar_on_amount_page_mobile: 'no_tip_jar_on_amount_page_mobile',
};
